import { useServices, useLoggedIn } from '../../../context';
import { useColorThemeState } from '../context';
import { useBiLogger } from '../../../hooks/useBiLogger/useBiLogger';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { BI_CONSTANTS } from '../../../hooks/useBiLogger/biConstants';
import { useSpec } from '../../../hooks/useSpec';
import { SelectThemeFirst } from '../../../experiments';
import { LocalStorageService } from '../../../services/storage/LocalStorageService';
import { DS_BUILDER_STORAGE_KEY, DsBuilderData } from '../../../types/localStorage';
import { APP_ROOT_URL, STORE_NAME_URL } from '../../../consts';

export const useTemplateNavigation = () => {
  const [{ selectedThemeColor }] = useColorThemeState();
  const { chatServiceDs: chatService } = useServices();
  const { navigate } = useAppNavigation();
  const biLogger = useBiLogger();
  const { ACTION, BUTTON_NAME } = BI_CONSTANTS;
  const isLoggedIn = useLoggedIn();
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);
  const localStorageService = new LocalStorageService();

  const handleNext = async () => {
    biLogger.actionClicked({
      action: ACTION.THEME_SELECTOR_NEXT,
      button_name: BUTTON_NAME.NEXT,
      value: selectedThemeColor || '',
    });

    if (shouldSelectThemeFirst && !isLoggedIn) {
      await localStorageService.updateObjectKey<DsBuilderData>(DS_BUILDER_STORAGE_KEY, {
        selectedThemeColor,
      });

      const url = new URL(window.location.href);
      window.location.href = `${url.origin}${APP_ROOT_URL}${STORE_NAME_URL}${url.search}`;
      return;
    }

    if (!shouldSelectThemeFirst) {
      chatService.updateTheme(selectedThemeColor);
    }
    navigate(STORE_NAME_URL);
  };

  return {
    handleNext,
  };
};
